<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <template v-slot:activator="{ on: dialogo }">
      <v-list-item v-on="dialogo" @click.stop="dialog = true">
        <v-icon class="red--text">mdi-trash-can-outline</v-icon>
        <v-list-item-title class="red--text"> Eliminar</v-list-item-title>
      </v-list-item>
    </template>
    <!-- Modal -->
    <v-card>
      <!-- Título -->
      <v-card-title>
        ¿Estás seguro de que deseas eliminar esta venta?
      </v-card-title>
      <!-- Acciones posibles -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- Botón que cancela la operación -->
        <v-btn :color="mainColor" text @click="dialog = false">Cancelar</v-btn>
        <!-- Detonador para eliminar la venta -->
        <v-btn class="red--text" text @click="deleteSale">Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable no-unused-vars */
// importar servicios
import MovementsServices from "@/services/MovementsServices";
export default {
  props: {
    movementId: {
      type: String
    }
  },
  data() {
    return {
      mainColor: "#1DDF96",
      dialog: false
    };
  },
  methods: {
    deleteSale: async function() {
      // Generamos peticion
      try {
        // Constante para almacenar lo que regrese la petición
        await MovementsServices.deleteSale(this.movementId);

        // Se cierra el dialogo si todo sale éxitoso
        this.dialog = false;

        // Emitir mensaje
        this.$emit("sale-deleted");
      } catch (err) {
        // Emitir el error
        this.$emit("sale-error", err.message);
      }
    }
  }
};
</script>
